import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-crm-case-detail',
  templateUrl: './case-detail.component.html',
  styleUrls: ['./case-detail.component.css'],
  host: { class: 'workspace-page--full' },
})
export class CrmCaseDetailComponent implements OnInit {
  caseId = 0;
  detail: any = null;
  loading = false;
  saving = false;
  editing = false;
  editForm!: FormGroup;
  resolutionNote = '';
  users: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private fb: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    public auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.caseId = +this.route.snapshot.paramMap.get('id')!;
    this.editForm = this.fb.group({
      title:            ['', [Validators.required, Validators.maxLength(255)]],
      description:      ['', Validators.maxLength(2000)],
      relatedRef:       ['', Validators.maxLength(128)],
      assignedToUserId: [null],
    });
    this.loadUsers();
    this.load();
  }

  load(): void {
    this.loading = true;
    this.http.get<any>(`/api/cases/${this.caseId}`).subscribe({
      next: data => { this.detail = data; this.loading = false; },
      error: () => {
        this.snackBar.open('Failed to load case.', 'OK', { duration: 4000 });
        this.loading = false;
      }
    });
  }

  loadUsers(): void {
    this.http.get<{ items: any[] }>('/api/users').subscribe({
      next: resp => { this.users = resp.items ?? []; },
      error: () => {}
    });
  }

  back(): void {
    this.router.navigate(['/cases']);
  }

  startEdit(): void {
    this.editing = true;
    this.editForm.patchValue({
      title:            this.detail.title,
      description:      this.detail.description ?? '',
      relatedRef:       this.detail.relatedRef ?? '',
      assignedToUserId: this.detail.assignedToUserId ?? null,
    });
  }

  cancelEdit(): void {
    this.editing = false;
  }

  submitEdit(): void {
    if (this.editForm.invalid) return;
    this.saving = true;
    this.http.put(`/api/cases/${this.caseId}`, this.editForm.value).subscribe({
      next: () => {
        this.saving = false;
        this.editing = false;
        this.snackBar.open('Case updated.', undefined, { duration: 2500 });
        this.load();
      },
      error: (e: any) => {
        this.saving = false;
        this.snackBar.open(e?.error?.message ?? 'Failed to save case.', 'OK', { duration: 5000 });
      }
    });
  }

  closeCase(): void {
    if (!this.resolutionNote.trim()) return;
    this.saving = true;
    this.http.post(`/api/cases/${this.caseId}/close`, { resolutionNote: this.resolutionNote }).subscribe({
      next: () => {
        this.saving = false;
        this.resolutionNote = '';
        this.snackBar.open('Case closed.', undefined, { duration: 2500 });
        this.load();
      },
      error: (e: any) => {
        this.saving = false;
        this.snackBar.open(e?.error?.message ?? 'Failed to close case.', 'OK', { duration: 5000 });
      }
    });
  }

  reopenCase(): void {
    this.saving = true;
    this.http.post(`/api/cases/${this.caseId}/reopen`, {}).subscribe({
      next: () => {
        this.saving = false;
        this.snackBar.open('Case reopened.', undefined, { duration: 2500 });
        this.load();
      },
      error: (e: any) => {
        this.saving = false;
        this.snackBar.open(e?.error?.message ?? 'Failed to reopen case.', 'OK', { duration: 5000 });
      }
    });
  }
}
